import React, { useEffect, useMemo, useState } from "react";
import {
    Search, Filter, Download, FileText, MoreHorizontal,
    ArrowUpDown, ArrowUp as ArrowUpIcon, ArrowDown,
    CheckSquare, Square, ChevronLeft, ChevronRight, Calendar, Users
} from "lucide-react";
import DetailsModal from "./DetailsModal";
import Dashboard from "../dashboard/Dashboard";
import TopNavigation from "./TopNavigation";

const ProcessingDataTable = ({ data, totalRecords, onPageChange, clients }) => {
    // ---------------------------------------------------------
    // 🔹 STATES
    // ---------------------------------------------------------
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    // ❗ Server-side Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    // Row Selection UI State
    const [selectedRows, setSelectedRows] = useState(new Set());

    const [viewRow, setViewRow] = useState(null); // State for modal



    // ---------------------------------------------------------
    // 🔹 Search (client-side)
    // ---------------------------------------------------------
    const filteredData = useMemo(() => {
        if (!searchTerm) return data;
        const lower = searchTerm.toLowerCase();
        return data.filter(row =>
            Object.values(row).some(val =>
                String(val).toLowerCase().includes(lower)
            )
        );
    }, [data, searchTerm]);


    // ---------------------------------------------------------
    // 🔹 Sorting (client-side)
    // ---------------------------------------------------------
    const sortedData = useMemo(() => {
        if (!sortConfig.key) return filteredData;

        return [...filteredData].sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key])
                return sortConfig.direction === "asc" ? -1 : 1;
            if (a[sortConfig.key] > b[sortConfig.key])
                return sortConfig.direction === "asc" ? 1 : -1;
            return 0;
        });
    }, [filteredData, sortConfig]);


    // ---------------------------------------------------------
    // 🔹 Server-side Pagination
    // ---------------------------------------------------------
    const totalPages = Math.ceil(totalRecords / rowsPerPage);


    // ---------------------------------------------------------
    // 🔹 Sorting handler
    // ---------------------------------------------------------
    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };


    // ---------------------------------------------------------
    // 🔹 Selection handlers
    // ---------------------------------------------------------
    const toggleSelection = (id) => {
        const newSet = new Set(selectedRows);
        newSet.has(id) ? newSet.delete(id) : newSet.add(id);
        setSelectedRows(newSet);
    };

    const toggleAllSelection = () => {
        if (selectedRows.size === data.length) setSelectedRows(new Set());
        else setSelectedRows(new Set(data.map(r => r.id)));
    };


    // ---------------------------------------------------------
    // 🔹 Table Header Config
    // ---------------------------------------------------------
    const headers = [
        { label: 'Client', key: 'uuid', width: 'w-32' },
        { label: 'Source', key: 'source', width: 'w-24' },
        { label: 'File Id', key: 'fileId', width: 'w-28' },
        { label: 'File Name', key: 'fileName', width: 'w-64' },
        { label: 'Stage', key: 'currentStage', width: 'w-40' },
        { label: 'Status', key: 'status', width: 'w-28' },
        { label: 'Start Time', key: 'startTime', width: 'w-40' },
        { label: 'End Time', key: 'endTime', width: 'w-40' },
        { label: 'Done', key: 'allDone', width: 'w-20' },
    ];

    const cleanHTML = (value) => {
        if (!value) return "";
        return value.replace(/<[^>]*>/g, "").trim();
    };


    return (
        <div className="mx-auto">
            <div className=" min-h-screen bg-slate-50 dark:bg-slate-900 text-slate-900 dark:text-slate-100 font-sans p-4 md:p-8 transition-colors duration-200">

                    {/* Modal */}

                    {viewRow && <DetailsModal row={viewRow} onClose={() => setViewRow(null)} clientName={clients} />}
                    <TopNavigation />
                    <Dashboard/>

            </div>
        </div>

    );
};

export default ProcessingDataTable;
